// /* eslint-disable react-hooks/exhaustive-deps */
import {
  AlertTost,
  CustomInput,
  CustomModal,
  CustomPhoneInput,
  CustomTable,
  FilterBar,
  RowAction,
} from "#components";
import { AdminLayout, TableLayout } from "#layouts";
import { addGrowerDetails } from "#redux/feature/growerSlice.js";
import { AdminRoutePath } from "#routes/routePath.jsx";
import { growerTableHeader } from "#utils/seeds.js";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CustomAlert from "../../components/CustomAlert copy";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { growerInitialValues } from "#validations/initialValues.js";
import { growerValidationSchema } from "#validations/validationSchema.js";
import usePost from "#hooks/usePost.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import useDelete from "#hooks/useDelete.js";
import usePut from "#hooks/usePut.js";

import { useNavigate } from "react-router-dom";
import useGet from "#hooks/useGet.js";
import globalConfig from "#constants/globalConfig.js";

const GrowersManagement = ({ agronomistId }) => {
  const navigation = useNavigate();

  const [dataCount, setDataCount] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [growerDetails, setGrowerDetails] = useState(null);
  const [dragging, setDragging] = useState(false);

  const [open, setOpen] = useState({
    add: false,
    edit: false,
  });

  const onOpen = (key, data) => {
    setOpen({ ...open, [key]: true });
    setGrowerDetails(data);
  };

  const onClose = (key) => {
    setOpen({
      ...open,
      [key]: false,
    });
    setGrowerDetails(null);
    resetForm();
  };

  const {
    data: growerListData,
    isLoading: isGrowerLoading,
    refetch: refetchGrowerList,
  } = useGet(ENDPOINTS.GROWER_LISTING, QUERY_KEYS.GROWER_LISTING_QUERY_KEY, {
    agroId: agronomistId,
    page: currentPage.toString(),
    limit: dataCount,
    search: searchInput,
  });

  const { mutateAsync: editGrowerMutateAsync, isLoading: isLoadingEditGrower } =
    usePut(ENDPOINTS.GROWER_EDIT, QUERY_KEYS.GROWER_EDIT_QUERY_KEY);

  const {
    mutateAsync: statusGrowerMutateAsync,
    isLoading: isLoadingStatusGrower,
  } = usePut(ENDPOINTS.GROWER_STATUS, QUERY_KEYS.GROWER_STATUS_QUERY_KEY);
  const { mutateAsync: addGrowerMutateAsync, isLoading: isLoadingAddGrower } =
    usePost(ENDPOINTS.ADD_GROWER, QUERY_KEYS.ADD_GROWER_QUERY_KEY);

  const { mutateAsync: deleteGrowerMutateAsync } = useDelete(
    ENDPOINTS.GROWER_DELETE,
    QUERY_KEYS.GROWER_DELETE_QUERY_KEY
  );

  const customValidate = (values) => {
    const errors = {};

    // Check if growerFileFile is provided
    if (!values.growerFile) {
      if (!values.firstName) errors.firstName = "First name is required*";
      if (!values.lastName) errors.lastName = "Last name is required*";
      if (!values.location) errors.location = "Location is required*";
    } else {
      // Clear errors when growerFileFile is provided
      if (values.email) delete errors.email;
      if (values.firstName) delete errors.firstName;
      if (values.lastName) delete errors.lastName;
      if (values.phoneNumber) delete errors.phoneNumber;
      if (values.location) delete errors.location;
    }

    return errors;
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: growerInitialValues,
    validationSchema: growerValidationSchema,
    // validate: customValidate,
    onSubmit: async (values) => {
      try {
        const data = {
          agroId: agronomistId,
          growerId: growerDetails?._id,
          firstName: values?.firstName,
          lastName: values?.lastName,
          email: values?.email,
          countryCode: values?.countryCode,
          phoneNumber: values?.phoneNumber,
          location: values?.location,
        };
        if (open.add) {
          try {
            const response = await addGrowerMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("add");
            refetchGrowerList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        } else {
          try {
            const response = await editGrowerMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("edit");
            await refetchGrowerList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        }
      } catch (error) {
        AlertTost("Something went wrong", "error");
      }
    },
  });

  useEffect(() => {
    if (open.edit) {
      setValues({
        firstName: growerDetails?.firstName,
        lastName: growerDetails?.lastName,
        countryCode: growerDetails?.countryCode,
        phoneNumber: growerDetails?.phoneNumber,
        location: growerDetails?.location,
        email: growerDetails?.email,
      });
    }
    if (searchInput === "") {
      refetchGrowerList();
    }
  }, [open.edit, searchInput]);

  // Handle count input change
  const onDataCountChange = (e) => {
    setDataCount(e.target.value);
    setCurrentPage(1);
  };

  //onSearch button
  const onSearchButtonClick = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    refetchGrowerList();
  };

  //onSearch Change
  const onSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    refetchGrowerList();
  }, [dataCount, currentPage]);

  const handleDeleteGrower = async (growerId) => {
    CustomAlert({
      title: " Are you sure you  want to delete the grower?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: async () => {
        try {
          await deleteGrowerMutateAsync({
            growerId: growerId,
          }).then((response) => {
            AlertTost(response?.message, "success");
            refetchGrowerList();
          });
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.message,
            icon: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      },
    });
  };

  const handleStatusOnChange = (item) => {
    statusGrowerMutateAsync({
      AgronomistId: item?._id,
    }).then(() => refetchGrowerList());
  };
  // Pagination function
  const handelPageChange = (action) => {
    setCurrentPage((prevPage) => prevPage + (action === "prev" ? -1 : 1));
  };
  const handelViewGrower = (id) => {
    localStorage.setItem(globalConfig.ADMIN_GROWER_ID, JSON.stringify(id));
    navigation(AdminRoutePath.GROWERS_DETAIL.path);
  };
  // drag and drop

  const handleDragOver = (e) => {
    e.preventDefault();
    if (!dragging) setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFieldValue("growerFile", droppedFile);
    }
  };

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFieldValue("growerFile", selectedFile);
    }
  };

  const handleRemoveFile = () => {
    setFieldValue("agronomistFile", null);
  };
  return (
    <>
      {" "}
      <section className="main-section spacer">
        <div className="container">
          {/* <FilterBar /> */}
          {/* <FilterBar
            onSearchButtonClick={onSearchButtonClick}
            onSearchChange={onSearchChange}
            searchInput={searchInput}
            onChange={onDataCountChange}
            rowLimit={dataCount}
          /> */}
          <div className="table_wrapper_card">
            <div className="row gy-3">
              <div className="col-xl-12">
                <div className="sub-heading flex-box">
                  <h2> Growers Listing </h2>
                  <div className="side-content-blk">
                    <button
                      onClick={() => onOpen("add")}
                      className="primary-btn"
                    >
                      Add New Grower
                    </button>
                  </div>
                </div>

                <TableLayout
                  tableHeader={growerTableHeader}
                  isEmpty={growerListData?.data?.list?.length === 0}
                  isLoading={isGrowerLoading}
                  currentPage={currentPage}
                  totalItems={growerListData?.data?.totalItems}
                  onDataCountChange={onDataCountChange}
                  handlePrevPage={() => handelPageChange("prev")}
                  handleNextPage={() => handelPageChange("next")}
                  rowLimit={dataCount}
                >
                  <CustomTable tableHeader={growerTableHeader}>
                    {growerListData?.data?.list.map((item, index) => {
                      return (
                        <tr key={index} className="cursor-pointer">
                          <td onClick={() => handelViewGrower(item._id)}>
                            {`${item?.firstName} ${item?.lastName}`}
                          </td>
                          <td onClick={() => handelViewGrower(item._id)}>
                            {item?.email || "NA"}
                          </td>
                          <td onClick={() => handelViewGrower(item._id)}>
                            {item?.location}
                          </td>
                          <RowAction
                            activeAction={{
                              edit: true,
                              view: true,
                              delete: true,
                              status: false,
                            }}
                            onEdit={() => onOpen("edit", item)}
                            onDelete={() => handleDeleteGrower(item._id)}
                            onView={() => {
                              handelViewGrower(item._id);
                            }}
                            onStatus={handleStatusOnChange}
                            isLoading={isLoadingStatusGrower}
                            item={item}
                          />
                        </tr>
                      );
                    })}
                  </CustomTable>
                </TableLayout>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  Grower modal */}
      <CustomModal
        open={open.add || open.edit}
        title={open.add ? "Add New Grower" : "Edit Grower"}
        actionButtonTitle="Submit"
        onClose={() => onClose(open.add ? "add" : "edit")}
        onSubmit={handleSubmit}
        loading={isLoadingAddGrower || isLoadingEditGrower}
      >
        <div className="common-modal-form">
          <div className="row gy-4">
            {/* <div className="col-12">
              <div className="mdl_sub_heading mb-3">
                <h2 className="mb-0 fs-6 fw-medium">Upload CSV</h2>
              </div>
              <div
                className="upload_file_wrapper"
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <input
                  type="file"
                  className="d-none"
                  id="fileUpload"
                  onChange={handleFileSelect}
                />
                <label htmlFor="fileUpload">
                  <span className="file_icon">
                    <img src="/assets/images/icon/file-icon.svg" alt="file" />
                  </span>
                  <span>Drag or drop here</span>
                  <span>or</span>
                  <span className="primary_text">Browse</span>
                </label>
              </div>

              {values.agronomistFile && (
                <div className="file_preview">
                  <span className="file_name">
                    {values.agronomistFile.name}
                  </span>
                  <button className="remove_file" onClick={handleRemoveFile}>
                    x
                  </button>
                </div>
              )}
            </div>
            <div className="col-12">
              <div className="text_divider text-center text-uppercase">or</div>
            </div> */}
            <div className="col-lg-6">
              <CustomInput
                label="First name"
                type="text"
                name="firstName"
                placeholder="Enter your first name"
                value={values?.firstName}
                error={errors.firstName}
                touched={touched.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-6">
              <CustomInput
                label="Last name"
                type="text"
                name="lastName"
                placeholder="Enter your last name"
                value={values?.lastName}
                error={errors.lastName}
                touched={touched.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-6">
              <CustomInput
                label="Email Address"
                type="text"
                name="email"
                placeholder="Enter your email address"
                value={values?.email}
                error={errors.email}
                touched={touched.email}
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={open.edit ? true : false}
              />
            </div>
            <div className="col-lg-6">
              <CustomPhoneInput
                label="Phone number"
                error={errors.phoneNumber}
                touched={touched.phoneNumber}
                countryCode={values.countryCode}
                phoneNumber={values.phoneNumber}
                setFieldValue={setFieldValue}
                disabled={open.edit ? true : false}
              />
            </div>
            <div className="col-lg-6">
              <CustomInput
                label="location"
                type="text"
                placeholder="Enter your location"
                name="location"
                value={values?.location}
                error={errors.location}
                touched={touched.location}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default GrowersManagement;
